import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

import AddUsersIco from "../../../../assets/icons/AddUsersIco";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import { StyledFlexColumnView } from "../../../common-components/StyledComponents";
import CommonTextField from "../../../../component/Input";
import CommonButton from "../../../../component/Button";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";
import DropDownSelect from "../../../../component/Select";

function AddEditKeyDeliverable({
  openDialog,
  handleCloseDialog,
  isEdit,
  handleChangeText,
  handleChange,
  formData,
  handleAddTeam,
  isLocation,
  selectedRowData,
}) {
  console.log(selectedRowData, "selectedRowData");
  const seniorityOptions = [
    { id: 1, name: "Senior" },
    { id: 2, name: "Mid-Level" },
    { id: 3, name: "Junior" },
  ];

  const locationOptions = [
    { id: 1, name: "Onsite" },
    { id: 2, name: "India" },
    { id: 3, name: "Hybrid" },
    { id: 3, name: "Romania" },
  ];

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={openDialog}
      onClose={handleCloseDialog}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          background: "#FFF",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        },
      }}
    >
      <StyledSpaceBetweenBox>
        <div>
          <IconButton
            size="small"
            sx={{
              border: "1px solid #D0D5DD",
              borderRadius: "8px",
              padding: "12px",
              marginLeft: "16px",
              marginTop: "16px",
            }}
          >
            <AddUsersIco />
          </IconButton>
        </div>
        {/* <DialogActions> */}
        <Button onClick={handleCloseDialog} sx={{ marginTop: "10px" }}>
          <XCloseIco />
        </Button>
        {/* </DialogActions> */}
      </StyledSpaceBetweenBox>
      <DialogTitle>
        <Typography variant="h3" sx={{ mt: 2 }}>
          {/* {isEdit ? "Edit Note" : "Create Note"} */}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Grid2 spacing={2} container>
          <Grid2 size={12}>
            <Typography variant="h2" color="#101828">
              {selectedRowData ? "Edit Key Deliverable" : "Add Key Deliverable"}
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <StyledFlexColumnView>
              <Typography fontWeight={500} fontSize={"16px"} color={"#344054"}>
                {"Key Deliverable"}
              </Typography>
              <CommonTextField
                fullWidth
                placeholder="Enter Key Deliverable"
                value={formData?.deliverable || ""}
                onChange={handleChangeText("deliverable")}
                padding={"0px"}
                multiline
                rows={4}
              />
            </StyledFlexColumnView>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <CommonButton
              variant="contained"
              color="white"
              background="#7F56D9"
              fontWeight="600"
              value={
                selectedRowData ? "Edit Key Deliverable" : "Add Key Deliverable"
              }
              padding="8px 20px"
              //   type="submit"
              fullWidth
              width={"100%"}
              onClick={handleAddTeam}
            />
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
}

export default AddEditKeyDeliverable;
